import React, { useEffect, useState } from 'react';
import './UnauthorizedScreen.css';

const FOOTER_DOCS = [
  {
    title: 'Правила сервиса',
    text: `Правила сервиса Calmaro
1. Общие положения
1.1. Настоящие Правила регулируют порядок использования сервиса Calmaro (далее – «Сервис») физическими лицами (далее – «Пользователь»).
1.2. Используя Сервис, Пользователь подтверждает согласие с настоящими Правилами, а также с условиями Публичной оферты.
1.3. Сервис предоставляет доступ к следующему функционалу:
— библиотека медитаций;
— дейли-практики;
— персональные рекомендации;
— трекер прогресса;
— внутренняя виртуальная единица «звёзды»;
— подписки и пакеты;
— реферальная программа;
— иные возможности, указанные в интерфейсе.

2. Регистрация и аккаунт
2.1. Для доступа к Сервису Пользователь проходит авторизацию через Telegram или иные доступные способы.
2.2. При регистрации Пользователь предоставляет данные, передаваемые Telegram автоматически (имя, никнейм, ID) и подтверждает их актуальность.
2.3. Пользователь несёт ответственность за сохранность доступа к своему Telegram-аккаунту и обязуется не передавать его третьим лицам.
2.4. Оператор вправе заблокировать или удалить аккаунт пользователя при нарушении настоящих Правил или условий Публичной оферты.

3. Использование сервиса
3.1. Сервис предназначен исключительно для личного использования Пользователем.
3.2. Сервис не является медицинской организацией, не оказывает медицинских, психотерапевтических или иных медицинских услуг, не ставит диагнозов.
Любые медитации, практики, тексты и рекомендации носят информационный и поддерживающий характер.
3.3. Пользователь самостоятельно оценивает и принимает все риски, связанные с использованием Сервиса.
3.4. Сервис может содержать платные функции, доступ к которым предоставляется при оплате подписок, пакетов или приобретении звёзд.

4. Внутренняя валюта и пакеты
4.1. В Сервисе используется внутренняя виртуальная единица — цветы.
4.2. Цветы приобретаются Пользователем за реальные деньги и могут использоваться только внутри Сервиса для доступа к платным функциям.
4.3. Цветы не являются денежными средствами, электронной валютой или ценной бумагой, не имеют номинальной стоимости и не подлежат обмену на реальные деньги или иные ценности.
4.4. Пользователь может приобретать пакеты услуг, которые предоставляют доступ к определённому функционалу или преимуществам внутри Сервиса.
4.5. Цветы и пакеты являются невозвратными и не подлежат обмену, за исключением случаев, прямо предусмотренных применимым законодательством.

5. Запреты для пользователей
Пользователю запрещается:
— использовать Сервис в коммерческих целях без согласия Оператора;
— передавать доступ к аккаунту третьим лицам;
— публиковать или передавать ложные, оскорбительные, агрессивные или противоправные материалы;
— предпринимать попытки обхода систем оплаты или ограничений доступа;
— копировать, распространять, изменять или использовать материалы Сервиса вне его функционала;
— использовать Сервис для рассылки спама, рекламы или мошеннических действий;
— предпринимать действия, которые могут нарушить работоспособность Сервиса или Telegram.

6. Конфиденциальность и данные
6.1. Обработка персональных данных Пользователя осуществляется в соответствии с Публичной офертой и Политикой конфиденциальности.
6.2. Пользователь соглашается на обработку данных, передаваемых через Telegram (имя, никнейм, ID), а также обезличенной статистики, необходимой для функционирования и улучшения Сервиса.
6.3. Контакт для обращений по вопросам данных — anri_yetimyan@mail.ru.

7. Ответственность и ограничения
7.1. Сервис предоставляется в формате «как есть». Оператор не гарантирует бесперебойную работу Сервиса или достижение Пользователем предполагаемого результата.
7.2. Оператор не несет ответственности за:
— действия Пользователя, совершённые на основе информации, полученной в Сервисе;
— технические сбои, вызванные оборудованием или программным обеспечением Пользователя, Telegram или провайдерами связи;
— невозможность использования Сервиса по причинам, не зависящим от Оператора.
7.3. Общая ответственность Оператора перед Пользователем ограничивается суммой, фактически уплаченной Пользователем за использование Сервиса за последние 30 календарных дней.

8. Заключительные положения
8.1. Настоящие Правила являются неотъемлемой частью Публичной оферты.
8.2. Оператор вправе изменять Правила в одностороннем порядке путем публикации новой редакции в Сервисе.
8.3. Продолжение использования Сервиса после публикации изменений означает согласие Пользователя с новой редакцией Правил.`,
  },
  {
    title: 'Публичная оферта',
    text: `ПУБЛИЧНАЯ ОФЕРТА О ПРЕДОСТАВЛЕНИИ ДОСТУПА К СЕРВИСУ CALMARO

1. Общие положения
1.1. Настоящий документ «Публичная оферта о предоставлении доступа к сервису Calmaro» (далее — «Оферта») является предложением Общества с ограниченной ответственностью «АНРИЭЛЛА» (налоговый номер: 06980179, регистрационный номер: 999.110.1559099 от 11.02.2026, юридический адрес: Республика Армения, 2021, г. Ванадзор, ул. Лазьяна, дом 14) (далее — «Оператор»), заключить договор возмездного оказания услуг (далее — «Договор») с любым дееспособным физическим лицом, акцептовавшим Оферту (далее — «Пользователь»), на условиях, предусмотренных Офертой.
1.2. Оферта адресована физическим лицам, достигшим 18 лет. Использование Сервиса лицами младше 18 лет не допускается.
1.3. Сервис Calmaro представляет собой программный комплекс Оператора, включающий мини-приложение внутри Telegram и серверное программное обеспечение, предоставляющее доступ к следующим функциям:
— библиотека медитаций;
— дейли-практики;
— трекер прогресса;
— персональные рекомендации;
— подписки, пакеты;
— внутренняя виртуальная единица («звёзды»);
— реферальная программа.
1.4. Акцепт Оферты осуществляется путём:
- регистрации/авторизации в Сервисе через Telegram;
- оформления подписки или покупки пакета;
- пополнения виртуальной единицы («цветы»);
- фактического использования платного функционала.
1.5. Сервис Calmaro предоставляет Пользователю доступ к функционалу в объёме, отображаемом в интерфейсе и соответствующем выбранным тарифам, подпискам и пакетам.
1.6. Сервис не является медицинским учреждением, не оказывает медицинских, телемедицинских, психотерапевтических услуг, не ставит диагнозов, не заменяет консультацию врача или специалиста. Материалы имеют информационный, образовательный и релаксационный характер.
1.7. Использование Сервиса предполагает соблюдение настоящей Оферты, а также Политики конфиденциальности и иных размещённых документов.
1.8. Оператор вправе изменять Оферту путём публикации новой редакции. Изменения применяются с момента публикации, если иное не указано.
1.9. Применимое право — законодательство Кыргызской Республики / РФ (укажите, что требуется).

2. Термины и определения
2.1. Сервис — программный комплекс Calmaro в Telegram.
2.2. Оператор — ООО «АНРИЭЛЛА».
2.3. Пользователь — физическое лицо, использующее Сервис.
2.4. Аккаунт — набор данных, формируемый автоматически при авторизации в Telegram.
2.5. Медитации — аудио- или текстовые материалы для расслабления и самопомощи.
2.6. Дейли-практики — ежедневные задания и упражнения.
2.7. Подписка — платный доступ к расширенному функционалу Сервиса. Может включать автопродление.
2.8. Внутренняя единица («цветы») — виртуальная единица, используемая для получения определённого функционала. Не является валютой.
2.9. Пакет — набор контента или функций за фиксированную плату.
2.10. Реферальная программа — система бонусов за приглашение новых пользователей.
2.11. Контент — любые материалы внутри Сервиса.
2.12. Оплата — денежные средства, внесённые Пользователем.

3. Предмет оферты
Оператор предоставляет доступ к функционалу Calmaro:
— медитациям;
— дейли-практикам;
— рекомендациям;
— трекеру прогресса;
— подпискам и пакетам;
— виртуальной валюте («звёздам»);
— реферальной программе.
Все услуги носят исключительно информационный и образовательный характер.

4. Регистрация и аккаунт
4.1. Регистрация осуществляется через Telegram Web App / интеграцию Telegram. Передаются имя, никнейм, ID.
4.2. Аккаунт создаётся автоматически.
4.3. Пользователь несёт ответственность за доступ к своему Telegram-аккаунту.
4.4. Запрещено передавать аккаунт третьим лицам.
4.5. Оператор вправе блокировать аккаунты нарушителей.

5. Права и обязанности сторон
Пользователь обязуется соблюдать Оферту, использовать сервис только для личных целей, не нарушать работу сервиса, своевременно оплачивать подписки.
Оператор обязуется обеспечивать доступность сервиса и информировать об изменениях условий.

6. Оплата и возвраты
6.1. Оплата осуществляется через встроенные платёжные системы Telegram или иные агрегаторы.
6.2. «Цветы» и пакеты — невозвратны, за исключением случаев, предусмотренных законом.
6.3. Подписка может включать автопродление — при наличии привязанного способа оплаты подписка продлевается автоматически.
6.4. «Цветы» не являются валютой, не имеют денежного эквивалента, не возвращаются и не обмениваются.
6.5. Пакеты имеют ограниченный срок действия.
6.6. При удалении аккаунта возвраты не производятся.

7. Ответственность сторон
7.1. Сервис не даёт гарантий результата.
7.2. Материалы не являются медицинской рекомендацией.
7.3. Пользователь использует контент на свой риск.
7.4. Оператор не несёт ответственности за сбои Telegram, устройства или интернет-канала пользователя.

8. Персональные данные
8.1. Пользователь передает Оператору свои персональные данные автоматически через Telegram.
8.2. Персональные данные включают:
— имя / никнейм;
— Telegram ID;
— автоматически передаваемые технические данные.
8.3. Данные используются для работы сервиса и аналитики.
8.4. Передача третьим сторонам не осуществляется, кроме случаев, предусмотренных законодательством.
8.5. Пользователь может отозвать согласие, но доступ к сервису будет прекращён.

9. Порядок разрешения споров
Претензионный порядок 30 дней, затем суд по адресу регистрации Оператора.

10. Заключительные положения
Оферта является полной договорённостью.
Недействительность отдельных положений не влияет на остальные.
Оператор имеет право изменять Оферту.

11. Реквизиты Оператора
ООО «АНРИЭЛЛА»
Налоговый номер: 06980179
Регистрационный номер: 999.110.1559099 от 11.02.2026
Юридический адрес: Республика Армения, 2021, г. Ванадзор, ул. Лазьяна, дом 14
Email для обращений по вопросам персональных данных: anri_yetimyan@mail.ru
Телефон: +3744307078`,
  },
  {
    title: 'Согласие на обработку',
    text: `Согласие на обработку персональных данных в сервисе Calmaro

Настоящим я, являясь Пользователем сервиса Calmaro (далее — «Сервис»), свободно, своей волей и в своём интересе даю своё согласие Обществу с ограниченной ответственностью «АНРИЭЛЛА» (налоговый номер: 06980179, регистрационный номер: 999.110.1559099 от 11.02.2026, юридический адрес: Республика Армения, 2021, г. Ванадзор, ул. Лазьяна, дом 14) (далее — «Оператор») на обработку моих персональных данных на следующих условиях:

1. Перечень персональных данных
Я подтверждаю и соглашаюсь, что Оператор обрабатывает следующие данные, автоматически передаваемые через Telegram или предоставленные мной при использовании Сервиса:
— Telegram ID;
— имя, никнейм и иные публичные данные Telegram;
— технические данные, необходимые для корректной работы Сервиса (язык интерфейса, тип устройства и т.п.);
— обезличенная статистика активности в Сервисе.
Оператор не собирает и не обрабатывает специальные категории персональных данных, сведения о здоровье, психическом состоянии, диагнозах и другие чувствительные данные.

2. Цели обработки персональных данных
Мои персональные данные могут обрабатываться Оператором для следующих целей:
— обеспечение функционирования Сервиса;
— предоставление доступа к медитациям, практикам, рекомендациям, подпискам и контенту;
— поддержка пользовательского аккаунта;
— обработка обращений в службу поддержки;
— выполнение обязательств по Публичной оферте;
— улучшение работы Сервиса и аналитика на основе обезличенных данных;
— отправка уведомлений, связанных с работой Сервиса.

3. Способы обработки данных
Обработка персональных данных осуществляется следующими способами:
— сбор, запись, хранение;
— систематизация и обезличивание;
— использование в функционале Сервиса;
— удаление по окончании цели обработки.
Обработка осуществляется как с использованием средств автоматизации, так и без них.

4. Передача третьим лицам
4.1. Оператор не передает персональные данные Пользователя третьим лицам, за исключением:
— случаев, прямо предусмотренных законодательством;
— случаев, когда передача необходима для исполнения обязательств перед Пользователем (например, платёжным операторам при оплате подписок).
4.2. Продажа, обмен или использование данных в маркетинговых целях третьих сторон исключены.

5. Срок хранения данных
Персональные данные хранятся Оператором:
— на период использования Сервиса;
— либо до момента удаления аккаунта Пользователем;
— либо до отзыва согласия.
После прекращения срока хранения данные удаляются или обезличиваются.

6. Права Пользователя
Пользователь имеет право:
— получать информацию о своих персональных данных;
— требовать их уточнения, обновления или исправления;
— отозвать согласие на обработку;
— требовать прекращения обработки и удаления данных;
— обращаться по вопросам обработки данных в службу поддержки: anri_yetimyan@mail.ru.
Отзыв согласия может привести к невозможности дальнейшего использования Сервиса.

7. Отзыв согласия
Я могу отозвать настоящее согласие направив запрос на адрес: anri_yetimyan@mail.ru.
После получения запроса Оператор прекращает обработку данных и удаляет их в установленные сроки, если иное не предусмотрено законом.

8. Заключительные положения
Настоящее согласие действует с момента его предоставления и до момента отзыва.
Использование Сервиса означает согласие с условиями обработки данных, изложенными в данном документе.`,
  },
  {
    title: 'Политика конфиденциальности',
    text: `Политика конфиденциальности сервиса Calmaro

1. Общие положения
1.1. Настоящая Политика конфиденциальности определяет порядок обработки и защиты персональных данных пользователей сервиса Calmaro (далее — «Сервис»).
1.2. Политика применяется ко всей информации, которую Оператор может получить о Пользователе при использовании Telegram-бота, сайта и иных интерфейсов Сервиса.
1.3. Используя Сервис, Пользователь подтверждает согласие с настоящей Политикой конфиденциальности.
1.4. Оператором персональных данных является Общество с ограниченной ответственностью «АНРИЭЛЛА» (налоговый номер: 06980179, регистрационный номер: 999.110.1559099 от 11.02.2026, юридический адрес: Республика Армения, 2021, г. Ванадзор, ул. Лазьяна, дом 14) (далее — «Оператор»).

2. Какие данные собираются
2.1. Оператор может обрабатывать следующие персональные данные Пользователя:
— Telegram ID;
— имя, username и иные публичные данные Telegram;
— адрес электронной почты;
— технические данные устройства и браузера;
— IP-адрес;
— cookie и технические идентификаторы;
— информация о подписках, оплатах и внутренней валюте;
— данные об использовании функционала Сервиса;
— обращения в службу поддержки;
— обезличенная статистика активности в Сервисе.
2.2. Оператор не осуществляет целенаправленный сбор специальных категорий персональных данных, связанных со здоровьем, политическими взглядами, религиозными убеждениями или интимной жизнью Пользователя.

3. Цели обработки персональных данных
3.1. Персональные данные Пользователя обрабатываются для следующих целей:
— регистрация и авторизация в Сервисе;
— предоставление доступа к материалам, рекомендациям и иному контенту;
— персонализация пользовательского опыта;
— предоставление подписок, пакетов и бонусов;
— обработка платежей и операций с внутренней валютой;
— работа службы поддержки;
— отправка сервисных уведомлений;
— отправка маркетинговых и рекламных сообщений при наличии отдельного согласия Пользователя;
— аналитика, улучшение и развитие Сервиса;
— обеспечение безопасности и предотвращение мошенничества;
— исполнение требований законодательства.

4. Правовые основания обработки данных
4.1. Оператор обрабатывает персональные данные на следующих основаниях:
— согласие Пользователя;
— заключение и исполнение договора;
— законные интересы Оператора;
— требования применимого законодательства.

5. Передача данных третьим лицам
5.1. Оператор вправе передавать персональные данные третьим лицам в следующих случаях:
— для обеспечения функционирования Сервиса;
— платёжным системам и банкам;
— подрядчикам, обеспечивающим техническую поддержку, аналитику, рассылки и хостинг;
— в случаях, предусмотренных законодательством.
5.2. Оператор не продаёт персональные данные Пользователей третьим лицам.
5.3. Передача данных в маркетинговых целях третьих сторон без согласия Пользователя не осуществляется.

6. Хранение и защита данных
6.1. Оператор принимает необходимые организационные и технические меры для защиты персональных данных от:
— неправомерного доступа;
— уничтожения;
— изменения;
— блокирования;
— копирования;
— распространения;
— иных неправомерных действий.
6.2. Доступ к персональным данным предоставляется только уполномоченным лицам, которым такая информация необходима для выполнения служебных обязанностей.
6.3. Персональные данные хранятся в течение срока, необходимого для достижения целей обработки, либо в течение срока, установленного законодательством.

7. Cookie и аналитика
7.1. Сервис может использовать cookie, SDK, пиксели и иные технологии аналитики.
7.2. Cookie используются для:
— корректной работы Сервиса;
— авторизации Пользователя;
— сохранения пользовательских настроек;
— анализа поведения пользователей;
— улучшения качества работы Сервиса.
7.3. Пользователь вправе ограничить использование cookie через настройки браузера, однако это может повлиять на корректность работы отдельных функций Сервиса.

8. Коммуникации и рассылки
8.1. Оператор вправе направлять Пользователю:
— сервисные уведомления;
— сообщения, связанные с работой Сервиса;
— уведомления о подписках, платежах и бонусах.
8.2. Рекламные и маркетинговые сообщения направляются только при наличии согласия Пользователя.
8.3. Пользователь вправе отказаться от получения рекламных сообщений в любой момент.

9. Права Пользователя
9.1. Пользователь вправе:
— получать информацию об обработке своих персональных данных;
— требовать уточнения, обновления или исправления данных;
— отозвать согласие на обработку данных;
— требовать прекращения обработки и удаления данных;
— обращаться по вопросам обработки персональных данных к Оператору.
9.2. Отзыв согласия на обработку персональных данных может привести к невозможности использования отдельных функций Сервиса.

10. Трансграничная передача данных
10.1. Пользователь соглашается, что отдельные данные могут обрабатываться и храниться за пределами страны нахождения Пользователя, если это необходимо для функционирования Сервиса, работы Telegram, платёжных систем, облачной инфраструктуры или аналитических сервисов.

11. Изменение политики
11.1. Оператор вправе изменять настоящую Политику конфиденциальности в одностороннем порядке.
11.2. Новая редакция вступает в силу с момента публикации в Сервисе.
11.3. Продолжение использования Сервиса означает согласие Пользователя с новой редакцией Политики.

12. Контакты
Оператор: ООО «АНРИЭЛЛА»
Налоговый номер: 06980179
Регистрационный номер: 999.110.1559099 от 11.02.2026
Юридический адрес: Республика Армения, 2021, г. Ванадзор, ул. Лазьяна, дом 14
Email для обращений по вопросам персональных данных: anri_yetimyan@mail.ru
Телефон: +3744307078`,
  },
];

const LANDING_RU = {
  subtitle: 'Онлайн-сервис медитаций',
  title: 'Calmaro — медитации для спокойствия, фокуса и внутреннего баланса',
  description: 'Ежедневные практики осознанности, дыхательные техники и расслабляющие аудиосессии для снижения стресса и улучшения качества жизни.',
  usersCount: '10 000+ пользователей',
  rating: '4.9 рейтинг',
  meditationsCount: '200+ медитаций',
  sleepBadge: 'Сон улучшился за 2 недели практики',
  whatTitle: 'Платформа для ментального здоровья и осознанной жизни',
  whatText: 'Calmaro — онлайн-платформа с профессионально разработанными медитациями и практиками осознанности. Мы помогаем тысячам людей находить внутреннее равновесие в ритме современной жизни.',
  benefit1: 'Снизить уровень стресса',
  benefit2: 'Улучшить качество сна',
  benefit3: 'Повысить концентрацию',
  benefit4: 'Справиться с тревожностью',
  benefit5: 'Развить эмоциональную устойчивость',
  feature1: 'Аудиомедитации',
  feature2: 'Дыхательные упражнения',
  feature3: 'Курсы осознанности',
  feature4: 'Ежедневные практики',
  whyTitle: 'Узнаёте себя?',
  whyProblems: 'Проблемы современного ритма жизни',
  problem1: 'Постоянный стресс и перегрузка',
  problem2: 'Сложности с концентрацией',
  problem3: 'Трудности со сном',
  problem4: 'Эмоциональное выгорание',
  whyPractices: 'Регулярные практики медитации',
  practice1: 'Снижают уровень кортизола',
  practice2: 'Улучшают качество сна',
  practice3: 'Восстанавливают ментальные ресурсы',
  practice4: 'Повышают устойчивость к стрессу',
  howTitle: 'Четыре простых шага к спокойствию',
  step1Title: 'Создайте аккаунт',
  step1Text: 'Быстрая регистрация за 30 секунд. Никаких лишних данных.',
  step2Title: 'Выберите цель',
  step2Text: 'Сон, снижение стресса, концентрация, борьба с тревогой — вы выбираете.',
  step3Title: 'Получите рекомендации',
  step3Text: 'Персональные практики на основе вашего запроса и уровня опыта.',
  step4Title: 'Практикуйте каждый день',
  step4Text: 'Отслеживайте прогресс, формируйте привычку и чувствуйте изменения.',
  advantagesTitle: 'Почему выбирают Calmaro',
  adv1Title: 'Удобный интерфейс',
  adv1Text: 'Интуитивно понятный дизайн — начните медитировать уже с первой минуты.',
  adv2Title: 'Подбор под цели',
  adv2Text: 'Алгоритм подберёт практики под вашу задачу: сон, стресс, концентрация.',
  adv3Title: 'От 5 минут',
  adv3Text: 'Короткие сессии вписываются в любой график — утром, в обед или вечером.',
  adv4Title: 'Новый контент',
  adv4Text: 'Регулярные обновления: новые медитации, курсы и практики каждую неделю.',
  adv5Title: 'Безопасность данных',
  adv5Text: 'Ваши данные надёжно защищены и никогда не передаются третьим лицам.',
  ctaTitle: 'Начните бесплатно прямо сейчас',
  ctaSubtitle: 'Присоединяйтесь к тысячам людей, которые уже обрели внутренний покой с Calmaro.',
  testimonialsTitle: 'Что говорят пользователи',
  testimonial1: '"После двух недель ежедневных медитаций я заметила, что стала намного спокойнее реагировать на стресс. Засыпать стало легче."',
  testimonial1Author: 'Анна К.',
  testimonial1Role: 'Маркетолог',
  testimonial2: '"Calmaro помогла мне справиться с тревожностью. Практики занимают всего 10 минут, а эффект ощущается уже через несколько дней."',
  testimonial2Author: 'Дмитрий В.',
  testimonial2Role: 'Предприниматель',
  testimonial3: '"Удобное приложение, мягкие голоса, приятная музыка. Рекомендую всем, кто хочет снизить уровень стресса."',
  testimonial3Author: 'Мария Л.',
  testimonial3Role: 'Врач',
  trustTitle: 'Мы заботимся о вашей безопасности',
  trustText: 'Сервис создан при участии профессиональных психологов и специалистов по медитативным практикам. Все данные хранятся на защищённых серверах в России в соответствии с ФЗ-152.',
  trust1: 'Данные защищены по ФЗ-152 о персональных данных',
  trust2: 'Шифрование передачи данных SSL/TLS',
  trust3: 'Сервис не является медицинской услугой',
  finalCtaTitle: 'Первый шаг к внутреннему покою — прямо сейчас',
  finalCtaSubtitle: 'Присоединяйтесь к сообществу людей, которые каждый день делают выбор в пользу ментального здоровья и осознанной жизни.',
  loginViaTelegram: 'Войти',
  widgetNotConfigured: '⚠️ Telegram виджет не настроен',
  widgetSetupHint: 'Необходимо установить VITE_TELEGRAM_BOT_USERNAME в файле .env',
  retrying: 'Повторная попытка...',
  footerLogoDesc: 'Онлайн-сервис медитаций для спокойствия, фокуса и внутреннего баланса.',
  footerDisclaimer: 'Сервис не является медицинской услугой и не заменяет профессиональную медицинскую помощь.',
  footerDocuments: 'Документы',
  footerContacts: 'Контакты',
  footerModalClose: 'Закрыть',
  footerEmail: 'anri_yetimyan@mail.ru',
  footerCopyright: '© 2026 Calmaro. Все права защищены.',
  footerCompanyLegal: 'ООО «АНРИЭЛЛА»',
} as const;

const LogoIcon: React.FC<{ className?: string }> = ({ className }) => {
  const gradientId = React.useId().replace(/:/g, '');
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#E8B896" />
          <stop offset="100%" stopColor="#E8B896" />
        </linearGradient>
      </defs>
      <rect width="24" height="24" rx="6" fill={`url(#${gradientId})`} />
    <circle cx="12" cy="12" r="4" fill="white" fillOpacity="0.9" />
    <path d="M12 2C12 2 8 6 8 12C8 18 12 22 12 22C12 22 16 18 16 12C16 6 12 2 12 2Z" fill="white" fillOpacity="0.6" />
    <path d="M2 12C2 12 6 8 12 8C18 8 22 12 22 12C22 12 18 16 12 16C6 16 2 12 2 12Z" fill="white" fillOpacity="0.6" />
  </svg>
  );
};

interface UnauthorizedScreenProps {
  onRetry: () => void;
  isRetrying?: boolean;
}

export const UnauthorizedScreen: React.FC<UnauthorizedScreenProps> = ({
  onRetry: _onRetry,
  isRetrying = false,
}) => {
  const r = LANDING_RU;
  const [docModal, setDocModal] = useState<{ title: string; text: string } | null>(null);
  const [testimonialIdx, setTestimonialIdx] = useState(0);

  const testimonials = [
    { quote: r.testimonial1, author: r.testimonial1Author, role: r.testimonial1Role },
    { quote: r.testimonial2, author: r.testimonial2Author, role: r.testimonial2Role },
    { quote: r.testimonial3, author: r.testimonial3Author, role: r.testimonial3Role },
  ] as const;

  // Один виджет — как в старой версии. Несколько виджетов конфликтуют (скрипт telegram-widget.js использует глобальное состояние).
  useEffect(() => {
    const botUsername = import.meta.env.VITE_TELEGRAM_BOT_USERNAME;
    if (!botUsername) return;

    const container = document.getElementById('telegram-login-container');
    if (!container) return;

    const script = document.createElement('script');
    script.src = '/vendor/telegram/telegram-widget.js?22';
    script.setAttribute('data-telegram-login', botUsername);
    script.setAttribute('data-size', 'large');
    script.setAttribute('data-radius', '8');
    script.setAttribute('data-auth-url', window.location.origin + '/api/telegram/auth');
    script.setAttribute('data-request-access', 'write');
    script.async = true;

    container.innerHTML = '';
    container.appendChild(script);

    return () => {
      container.innerHTML = '';
    };
  }, []);

  useEffect(() => {
    const t = setInterval(() => {
      setTestimonialIdx((i) => (i + 1) % testimonials.length);
    }, 7000);
    return () => clearInterval(t);
  }, [testimonials.length]);

  return (
    <div className="landing">
      <header className="landing-header">
        <div className="landing-header-inner">
          <div className="landing-logo">
            <LogoIcon />
            <span>Calmaro</span>
          </div>
          <div className="landing-header-actions">
            <a href="/login" className="landing-header-login-link">
              {r.loginViaTelegram}
            </a>
          </div>
        </div>
      </header>

      <main>
        {/* Hero */}
        <section className="landing-hero">
          <p className="landing-hero-subtitle">{r.subtitle}</p>
          <h1 className="landing-hero-title">{r.title}</h1>
          <p className="landing-hero-desc">{r.description}</p>
          <div className="landing-hero-cta">
            {/* Кнопки регистрации и входа уехали на отдельные страницы
                /registration и /login (Sofa 2026-05-20). На лендинге
                остаётся только большой переход на регистрацию. */}
            <a href={`/registration${window.location.search}`} className="landing-hero-register-button">
              Зарегистрироваться
            </a>
            <a href="/login" className="landing-hero-login-link">
              Уже есть аккаунт? Войти
            </a>
          </div>
          <div className="landing-stats">
            <span>🪷 {r.usersCount}</span>
            <span>⭐ {r.rating}</span>
            <span>📅 {r.meditationsCount}</span>
          </div>
          <div className="landing-sleep-badge">{r.sleepBadge}</div>
        </section>

        {/* What is Calmaro */}
        <section className="landing-section landing-what">
          <div className="landing-what-inner">
            <div className="landing-what-content">
              <h2 className="landing-section-title">{r.whatTitle}</h2>
              <p className="landing-section-text">{r.whatText}</p>
              <div className="landing-benefits">
                <span>{r.benefit1}</span>
                <span>{r.benefit2}</span>
                <span>{r.benefit3}</span>
                <span>{r.benefit4}</span>
                <span>{r.benefit5}</span>
              </div>
              <div className="landing-features">
                <span>{r.feature1}</span>
                <span>{r.feature2}</span>
                <span>{r.feature3}</span>
                <span>{r.feature4}</span>
              </div>
            </div>
            <div className="landing-what-image-wrap">
              <img
                src="/landing-meditation.jpg"
                alt="Медитация на природе"
                className="landing-what-image"
              />
            </div>
          </div>
        </section>

        {/* Why */}
        <section className="landing-section landing-why">
          <h2 className="landing-section-title">{r.whyTitle}</h2>
          <div className="landing-why-grid">
            <div className="landing-why-col">
              <h3>🚩 {r.whyProblems}</h3>
              <ul>
                <li>😰 {r.problem1}</li>
                <li>😵 {r.problem2}</li>
                <li>🌙 {r.problem3}</li>
                <li>🌅 {r.problem4}</li>
              </ul>
            </div>
            <div className="landing-why-col landing-why-col-success">
              <h3>✅ {r.whyPractices}</h3>
              <ul>
                <li>{r.practice1}</li>
                <li>{r.practice2}</li>
                <li>{r.practice3}</li>
                <li>{r.practice4}</li>
              </ul>
            </div>
          </div>
        </section>

        {/* How it works */}
        <section className="landing-section">
          <h2 className="landing-section-title">{r.howTitle}</h2>
          <div className="landing-steps">
            <div className="landing-step">
              <span className="landing-step-num">01</span>
              <h3>{r.step1Title}</h3>
              <p>{r.step1Text}</p>
            </div>
            <div className="landing-step">
              <span className="landing-step-num">02</span>
              <h3>{r.step2Title}</h3>
              <p>{r.step2Text}</p>
            </div>
            <div className="landing-step">
              <span className="landing-step-num">03</span>
              <h3>{r.step3Title}</h3>
              <p>{r.step3Text}</p>
            </div>
            <div className="landing-step">
              <span className="landing-step-num">04</span>
              <h3>{r.step4Title}</h3>
              <p>{r.step4Text}</p>
            </div>
          </div>
        </section>

        {/* Advantages */}
        <section className="landing-section">
          <h2 className="landing-section-title">{r.advantagesTitle}</h2>
          <div className="landing-advantages">
            <div className="landing-adv">
              <h3>{r.adv1Title}</h3>
              <p>{r.adv1Text}</p>
            </div>
            <div className="landing-adv">
              <h3>{r.adv2Title}</h3>
              <p>{r.adv2Text}</p>
            </div>
            <div className="landing-adv">
              <h3>{r.adv3Title}</h3>
              <p>{r.adv3Text}</p>
            </div>
            <div className="landing-adv">
              <h3>{r.adv4Title}</h3>
              <p>{r.adv4Text}</p>
            </div>
            <div className="landing-adv">
              <h3>{r.adv5Title}</h3>
              <p>{r.adv5Text}</p>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="landing-cta">
          <h2>{r.ctaTitle}</h2>
          <p>{r.ctaSubtitle}</p>
          <div className="telegram-login-section">
            <a href="/login" className="landing-scroll-to-widget">
              {r.loginViaTelegram}
            </a>
          </div>
        </section>

        {/* Testimonials */}
        <section className="landing-section">
          <h2 className="landing-section-title">{r.testimonialsTitle}</h2>
          <div className="landing-testimonials-slider">
            <div className="landing-testimonials-track">
              {testimonials.map((t, i) => (
                <div
                  key={i}
                  className={`landing-testimonial-slide ${i === testimonialIdx ? 'active' : ''}`}
                >
                  <div className="landing-testimonial">
                    <blockquote>{t.quote}</blockquote>
                    <div className="landing-testimonial-author">
                      <span className="landing-testimonial-avatar">{t.author.charAt(0)}</span>
                      <div>
                        <strong>{t.author}</strong>
                        <span>{t.role}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="landing-testimonials-dots">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  type="button"
                  className={`landing-testimonial-dot ${i === testimonialIdx ? 'active' : ''}`}
                  onClick={() => setTestimonialIdx(i)}
                  aria-label={`Отзыв ${i + 1}`}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Trust */}
        <section className="landing-section landing-trust">
          <h2 className="landing-section-title">{r.trustTitle}</h2>
          <p className="landing-section-text">{r.trustText}</p>
          <ul className="landing-trust-list">
            <li>{r.trust1}</li>
            <li>{r.trust2}</li>
            <li>{r.trust3}</li>
          </ul>
        </section>

        {/* Final CTA */}
        <section className="landing-cta landing-final-cta">
          <h2>{r.finalCtaTitle}</h2>
          <p>{r.finalCtaSubtitle}</p>
          <div className="telegram-login-section">
            <a href="/login" className="landing-scroll-to-widget">
              {r.loginViaTelegram}
            </a>
          </div>
        </section>
      </main>

      <footer className="landing-footer">
        <div className="landing-footer-inner">
          <div className="landing-footer-cols">
            <div className="landing-footer-col landing-footer-brand">
              <div className="landing-footer-logo">
                <LogoIcon />
                <span>Calmaro</span>
              </div>
              <p className="landing-footer-desc">{r.footerLogoDesc}</p>
              <p className="landing-footer-disclaimer">
                <span className="landing-footer-disclaimer-icon">⚠</span>
                {r.footerDisclaimer}
              </p>
            </div>
            <div className="landing-footer-col">
              <h3 className="landing-footer-heading">{r.footerDocuments}</h3>
              {FOOTER_DOCS.map((doc) => (
                <button
                  key={doc.title}
                  type="button"
                  className="landing-footer-link landing-footer-doc-link"
                  onClick={() => setDocModal(doc)}
                >
                  {doc.title}
                </button>
              ))}
            </div>
            <div className="landing-footer-col">
              <h3 className="landing-footer-heading">{r.footerContacts}</h3>
              <a href={`mailto:${r.footerEmail}`} className="landing-footer-link">{r.footerEmail}</a>
            </div>
          </div>
          <div className="landing-footer-bottom">
            <span>{r.footerCopyright}</span>
            <span>{r.footerCompanyLegal}</span>
          </div>
        </div>
      </footer>

      {docModal && (
        <div className="landing-doc-modal-overlay" onClick={() => setDocModal(null)}>
          <div className="landing-doc-modal" onClick={(e) => e.stopPropagation()}>
            <div className="landing-doc-modal-header">
              <h3 className="landing-doc-modal-title">{docModal.title}</h3>
              <button type="button" className="landing-doc-modal-close" onClick={() => setDocModal(null)}>
                {r.footerModalClose}
              </button>
            </div>
            <div className="landing-doc-modal-body">
              <pre className="landing-doc-modal-text">{docModal.text}</pre>
            </div>
          </div>
        </div>
      )}

      {isRetrying && (
        <div className="landing-retry-overlay">
          <span className="retry-spinner"></span>
          <span>{r.retrying}</span>
        </div>
      )}
    </div>
  );
};
